import { Component, OnInit } from '@angular/core';
import { SelfService } from '../self-services.service.ts';
import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import { Router } from '@angular/router';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';



@Component({
  selector: 'app-membership-report',
  templateUrl: './membership-report.component.html',
  styleUrls: ['./membership-report.component.css']
})
export class MembershipReportComponent implements OnInit {

  loginDetails: any;
  adminId: any
  msg1: string;
  method: string;
  param: any;
  siteList: any;
  loginDataDetails: any;
  leadAdminId: any;
  loginData: any;
  loginUserAdminId: any;
  userAndRoleIdDTO: any;
  chapterList: any;
  chapterIds: any;
  siteData: any;
  allSiteIds: any;
  createdBy: any;
  modifiedBy: any;
  selectedBpgsData: any;
  bpgList: any;
  selectedSiteId: any;
  selectedBpgId: any;
  selectedAreaImpactId: any;
  selectedSkillId: any;
  selectedInterestId: any;
  selectedBpg: any;
  allBpgIds: any;
  allAreaImpactIds: any;
  allSkillIds: any;
  allInterestIds: any;
  selectedSite: any;
  userId: any;
  landingDtoData: any;
  landingData: any;
  areaOfImpactList: any;
  skillList: any;
  leadershipInterestList: any;
  selectedAreaImpactIds: any;
  selectedSkillIds: any;
  selectedInterestIds: any;
  selectedAreaImpact: any;
  selectedSkills: any;
  selectedInterest: any;
  page: number = 0;
  limit: number = ConstantValues.pageLimit;
  membershipReportList = [];
  numberOfElements: number;
  noDataFound: boolean;
  tableShow: any;
  currentPage: number = 0;
  currentShowingElements: number = ConstantValues.pageLimit;
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  landingDtoPageExport: any;
  memberReportData2 = [];
  membershipType = [];
  selectedMembershipType: any;
  isbpgAdmin: boolean = false;
  isbpgLeadAdmin = false;

  /**
  * @class MembershipReportComponent
  * @constructor
  */
  constructor(
    private selfService: SelfService,
    
    private router: Router,
    private spinner: Ng4LoadingSpinnerService,
    private environment: EnvironmentConfiguration,
    private bpgEventsService: BpgEventsService,
    private bpgCommonService: BpgCommonService
  ) { }

  ngOnInit() {

    if (this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod') {
              if (localStorage.getItem('loginData')== null || localStorage.getItem('loginData')== undefined) {

        this.router.navigate(['/log-out']);
      }
    }

    if (localStorage.getItem('logOutFlag') == "true") {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/log-out']);
      localStorage.setItem("logOutFlag", "true");

    }
    if(localStorage.getItem('isbpgAdmin') == 'true')
    {
      this.isbpgAdmin = true;
   }  
   if(localStorage.getItem('isbpgLeadAdmin') === 'true')
   {
     this.isbpgLeadAdmin = true;
  }  
    localStorage.removeItem('searchedEventsCaledarItems');

    this.loginDataDetails = JSON.parse(localStorage.getItem('loginData'));

    localStorage.removeItem('searchedEventsCaledarItems');
    this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
    this.adminId = localStorage.getItem('adminId');

    // if (this.loginDetails == null) {
    //   this.router.navigate(['/login']);
    // }
    // this.spinner.show();
    sessionStorage.removeItem("MembershipData");
    this.selectedSiteId = localStorage.getItem('userSiteId');
    this.leadAdminId = localStorage.getItem('leadAdminId');
    if (this.leadAdminId === 'true' && !this.isbpgAdmin) {
      localStorage.setItem('adminId', '2');

    }
    this.loginUserAdminId = localStorage.getItem('adminId');

    this.userAndRoleIdDTO = {
      userId: this.loginDataDetails['userId'],
      roleId: localStorage.getItem('adminId')

    }

    this.membershipType = [
      { typeId: 'ALL', typeName: 'Select All' },
      { typeId: 'REGULAR', typeName: 'Regular' },
      { typeId: 'VIRTUAL', typeName: 'Virtual' }
    ];

    this.selectedMembershipType = 'ALL';

    this.loginData = JSON.parse(localStorage.getItem('loginData'));
    this.createdBy = this.loginData.userId;
    this.modifiedBy = this.loginData.userId;

    if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {
      // this.getSiteforAdmins();
      this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(data => {
        this.chapterList = data;
        if (this.chapterList.length > 1) {
          this.chapterList.unshift({ chapterId: 0, siteName: 'Select All', bpgName: '' });
        }
        for (let i = 0; i < this.chapterList.length; i++) {
          if (i == 0) {
            this.chapterIds = this.chapterList[i].chapterId;
          }
          else {
            this.chapterIds = this.chapterIds + "," + this.chapterList[i].chapterId;
          }
        }

        this.siteData = {
          "filter": {
            chapterId: this.chapterIds
          },
          "moduleId": 0,
          "page": 0,
          "presentRole": "",
          "searchTerm": "",
          "size": 0,
          "sortDirection": "ASC",
          "sortProperty": "",
          "uid": ""
        }
        this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
          this.siteList = data;
          //filter default site from sitelist
          this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT');
          this.siteList.unshift({ siteId: 0, siteName: 'Select Site', bpgName: '' });

          for (let i = 0; i < this.siteList.length; i++) {
            if (i == 0) {
              this.allSiteIds = this.siteList[i].siteId;
            } else {
              this.allSiteIds = this.allSiteIds + this.siteList[i].siteId + ",";
            }
          }
          this.getBpgList();

        });
      });

      console.log(this.selectedBpgId + '\n', this.selectedAreaImpactId + '\n', this.selectedSkillId + '\n', this.selectedInterestId + '\n')


      this.getSiteName();
      this.getAreaOfImpactList();
      this.getSkillsList();
      this.getLeadershipInterestList();

    }
    else if (this.loginUserAdminId === "1") {
      this.getSiteName()
      this.getSiteList();
      this.getBpgList();
      this.getAreaOfImpactList();
      this.getSkillsList();
      this.getLeadershipInterestList();

    }

    console.log(this.selectedBpgId + '\n', this.selectedAreaImpactId + '\n', this.selectedSkillId + '\n', this.selectedInterestId + '\n')

  }


  /** get site name in the dropdown for lead admin
  * @class MembershipReportComponent
  * @method getSiteName
  */
  getSiteName() {
    this.selectedSite = this.loginData.site.siteName;
  }

  /** get site list in the dropdown
    * @class MembershipReportComponent
    * @method getSiteList
    */
  getSiteList() {
    this.siteData = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }

    this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
      this.siteList = data;
      //filter default site from sitelist
      this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT');
      this.siteList.unshift({ siteId: 0, siteName: 'Select All', bpgName: '' });

      if (this.siteList != null) {
        for (var i = 0; i < this.siteList.length; i++) {
          if (this.siteList[i].siteId == this.selectedSiteId) {
            this.selectedSite = this.siteList[i].siteName;
          }
        }

        for (let i = 0; i < this.siteList.length; i++) {
          if (i == 0) {
            this.allSiteIds = this.siteList[i].siteId;
          } else {
            this.allSiteIds = this.allSiteIds + this.siteList[i].siteId + ",";
          }
        }

      }
    });
  }

  /** For site change from site list 
   * @class MembershipReportComponent
   * @method siteChange
   * @returns Promise
   */
  siteChange(event) {
    this.selectedBpgId = 0;
    this.selectedBpg = null;
    this.userId = null;
    this.selectedSiteId = event.siteId;
    this.bpgList = [];
    this.getBpgList();
  }

  /** For bpg change from bpg list 
* @class MembershipReportComponent
* @method bpgChange
* @returns Promise
*/

  bpgChange(event) {
    this.selectedBpgId = null;
    this.userId = null;
    this.selectedBpgId = event.bpgId;
    this.resetPageOnDropownChange();
  }

  /** For bpg change from bpg list 
* @class MembershipReportComponent
* @method membershipTypeChange
* @returns Promise
*/

  membershipTypeChange(event) {
    this.selectedMembershipType = null;
    this.selectedMembershipType = event.typeId;
    this.resetPageOnDropownChange();
  }

  /** get bpg list in the dropdown
* @class MembershipReportComponent
* @method getBpgList
*/
  getBpgList() {
    this.selectedBpgsData =
    {
      "filter": {
        "siteId": this.selectedSiteId,
        "adminId": this.loginUserAdminId,
        "userId": this.createdBy
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": "string"
    }
    this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
      this.bpgList = data;
      if (this.bpgList.length != 0) {
        this.bpgList.unshift({ bpgId: 0, bpgName: 'Select All' });
      } else {
        this.bpgList.unshift({ bpgId: 0, bpgName: 'No Data found' });
      }

      if (this.bpgList != null) {

        for (var i = 0; i < this.bpgList.length; i++) {
          // this.allBpgIds.push(this.bpgList[i].bpgId);
          if (this.bpgList[i].bpgId == this.selectedBpgId) {
            this.selectedBpg = this.bpgList[i].bpgName;
          }
        }

        for (let i = 0; i < this.bpgList.length; i++) {
          if (i == 0) {
            this.allBpgIds = this.bpgList[i].bpgId;
          } else {
            this.allBpgIds = this.allBpgIds + this.bpgList[i].bpgId + ",";
          }
        }

        // if (this.loginUserAdminId == 2 ||this.loginUserAdminId == 3) {
        //   this.getMembershipReportList();
        //   }
      }

    });
  }


  areaOfImpactChange(event) {
    this.selectedAreaImpactId = this.selectedAreaImpact;
    var array1 = this.selectedAreaImpactId;
    this.selectedAreaImpactId = array1.toString();
    this.resetPageOnDropownChange();
  }


  skillsChange(event) {
    this.selectedSkillId = this.selectedSkills;
    var array2 = this.selectedSkillId;
    this.selectedSkillId = array2.toString();
    this.resetPageOnDropownChange();
  }

  leadershipTypeChange(event) {
    this.selectedInterestId = this.selectedInterest;
    var array3 = this.selectedInterestId;
    this.selectedInterestId = array3.toString();
    this.resetPageOnDropownChange();
  }

  /* to reset the data and pagination numbers on dropdown change */
  resetPageOnDropownChange() {
    this.membershipReportList = [];
    this.tableShow = false;
    this.page = 0;
    this.currentPage = 1;
    this.currentShowingElements = this.currentPage * this.limit;
  }


  /**
  * @class MembershipReportComponent
  * @method getAreaOfImpactList
  */
  getAreaOfImpactList() {
    this.landingDtoData = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }

    this.selfService.getAllAreaOfImpact(this.landingDtoData).subscribe(data => {
      this.areaOfImpactList = data;
      this.areaOfImpactList.map((i) => { i.areaImpact = i.category + ' - ' + i.subCategory; return i; })

      if (this.areaOfImpactList.length > 1) {
        this.areaOfImpactList.unshift({ areaOfImpactId: 0, areaImpact: 'Select All', subCategory: '' });
      } else {
        this.areaOfImpactList.unshift({ areaOfImpactId: 0, areaImpact: 'No Data found', subCategory: '' });
      }

      if (this.areaOfImpactList != null) {

        for (let i = 0; i < this.areaOfImpactList.length; i++) {
          if (i == 0) {
            this.allAreaImpactIds = this.areaOfImpactList[i].areaOfImpactId;
          } else {
            this.allAreaImpactIds = this.allAreaImpactIds + this.areaOfImpactList[i].areaOfImpactId + ",";
          }
        }
      }

    });
  }

  /**
* @class MembershipReportComponent
* @method getSkillsList
*/
  getSkillsList() {
    this.landingDtoData = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }

    this.selfService.getAllSkill(this.landingDtoData).subscribe(data => {
      this.skillList = data;
      if (this.skillList.length > 1) {
        this.skillList.unshift({ skillId: 0, skillName: 'Select All' });
      } else {
        this.skillList.unshift({ skillId: 0, skillName: 'No data found' });
      }

      if (this.skillList != null) {
        for (let i = 0; i < this.skillList.length; i++) {
          if (i == 0) {
            this.allSkillIds = this.skillList[i].skillId;
          } else {
            this.allSkillIds = this.allSkillIds + this.skillList[i].skillId + ",";
          }
        }
      }

    });
  }


  /**
  * @class MembershipReportComponent
  * @method getLeadershipInterestList
  */
  getLeadershipInterestList() {
    this.leadershipInterestList = [
      // { leadershipTypeId: 0, leadershipType: "Select All" },
      { leadershipTypeId: 1, leadershipType: "Chair" },
      { leadershipTypeId: 2, leadershipType: "Vice Chair" },
      { leadershipTypeId: 3, leadershipType: "Communications Chair" },
      { leadershipTypeId: 4, leadershipType: "Finance Chair" }]

    if (this.leadershipInterestList.length > 1) {
      this.leadershipInterestList.unshift({ leadershipTypeId: 0, leadershipType: 'Select All' });
    }

    if (this.leadershipInterestList != null) {
      for (let i = 0; i < this.leadershipInterestList.length; i++) {
        if (i == 0) {
          this.allInterestIds = this.leadershipInterestList[i].leadershipTypeId;
        } else {
          this.allInterestIds = this.allInterestIds + this.leadershipInterestList[i].leadershipTypeId + ",";
        }
      }
    }
  }

  /* Method on click of generate */
  generateMembershipReport() {
    this.spinner.show();
    this.getMembershipReportList();
    setTimeout(() => {
      this.spinner.hide();
    }, 500);

  }

  /**
  * Method to get the data for membership report 
  * @class MembershipReportComponent
  * @method getMembershipReportList
  */
  getMembershipReportList() {
    console.log(this.selectedBpgId + '\n', this.selectedAreaImpactId + '\n', this.selectedSkillId + '\n', this.selectedInterestId + '\n')

    if (this.selectedSiteId == 0) {
      this.selectedSiteId = this.allSiteIds;
    }

    if (this.selectedBpgId == undefined) {
      this.selectedBpgId = null;
    } else if (this.selectedBpgId == 0) {
      this.selectedBpgId = this.allBpgIds;
    }

    if (this.selectedMembershipType == undefined) {
      this.selectedMembershipType = null;
    }

    if (this.selectedAreaImpactId == undefined) {
      this.selectedAreaImpactId = null;
    } else if (this.selectedAreaImpactId == 0) {
      this.selectedAreaImpactId = this.allAreaImpactIds;
    }
    if (this.selectedSkillId == undefined) {
      this.selectedSkillId = null;
    } else if (this.selectedSkillId == 0) {
      this.selectedSkillId = this.allSkillIds;
    }
    if (this.selectedInterestId == undefined) {
      this.selectedInterestId = null;
    } else if (this.selectedInterestId == 0) {
      this.selectedInterestId = this.allInterestIds;
    }

    this.landingData = {
      "filter": {
        "siteId": this.selectedSiteId, "bpgId": this.selectedBpgId,
        "areaImpactId": this.selectedAreaImpactId, "skillId": this.selectedSkillId,
        "leadershipPositionId": this.selectedInterestId,
        "membershipType": this.selectedMembershipType
      },
      "moduleId": 0,
      "page": this.page,
      "presentRole": "string",
      "searchTerm": "string",
      "size": this.limit,
      "uid": "string"
    }

    console.log(JSON.stringify(this.landingData))
    this.selfService.getMembershipReport(this.landingData).subscribe(data => {
      this.membershipReportList = data.content;
      this.tableShow = true;
      console.log(JSON.stringify(this.membershipReportList));
      this.numberOfElements = data.totalElements;

      if (this.membershipReportList.length == 0) {
        this.noDataFound = true;
        this.tableShow = false;
      } else {
        this.noDataFound = false;
        this.tableShow = true;
      }
    }, err => {
      this.spinner.hide();
      console.log(JSON.stringify(err.value.message));
      if (err.value.statusText == ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }


  /** For filtering data by current page 
   * @class MembershipReportComponent
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {
    this.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.getMembershipReportList();
  }


  resetClick() {
    this.method = "resetMembershipReport";
    this.param = '';
    this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
  }

  resetMembershipReport() {
    this.spinner.show();
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      this.spinner.hide();
    }, 400);
    this.selectedBpg = null;
    this.selectedBpgId = 0;
    this.selectedAreaImpactId = 0;
    this.selectedSkillId = 0;
    this.selectedInterestId = 0;
    this.selectedAreaImpact = null;
    this.selectedSkills = null;
    this.selectedInterest = null;
    this.selectedSiteId = localStorage.getItem('userSiteId');
    this.selectedSite = this.loginData.site.siteName;
    this.membershipReportList = [];
    this.tableShow = false;
    this.currentPage = 0;
    this.noDataFound = false;
    this.selectedMembershipType = null;
    // this.numberOfElements = null;

    if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {
      this.selectedSiteId = 0;
      this.selectedBpgId = 0;
      this.selectedAreaImpactId = 0;
      this.selectedSkillId = 0;
      this.selectedInterestId = 0;
      this.getBpgList();
    }
    // this.getMembershipReportList();
    this.getBpgList();
  }

  /** For service call to convert json to csv and save file 
  * @method exportAsCSV
  */
  exportAsCSV() {
    this.landingDtoPageExport = {
      "filter": {
        "siteId": this.selectedSiteId, "bpgId": this.selectedBpgId,
        "areaImpactId": this.selectedAreaImpactId, "skillId": this.selectedSkillId,
        "leadershipPositionId": this.selectedInterestId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 100000,
      "uid": "string"
    }

    this.selfService.getMembershipReport(this.landingDtoPageExport).subscribe(data => {
      this.memberReportData2 = data.content;
      this.bpgEventsService.exportAsExcelFile(this.memberReportData2, "Membership_Report");
    });
  }

}
